module.exports = __webpack_public_path__ + "img/碳中宝.0f0f416f.png";